import React from 'react';
import Icon from 'components/AppIcon';
import TrainingProgressIndicator from 'components/ui/TrainingProgressIndicator';

const STATUS_STEPS = ['new', 'trained', 'established', 'senior'];
const STATUS_LABELS = { new: 'New', trained: 'Trained', established: 'Established', senior: 'Senior' };
const STATUS_ICONS = { new: 'Sprout', trained: 'GraduationCap', established: 'Star', senior: 'Award' };

export default function StatusProgressPanel({ volunteer, enrolledCourses }) {
  const currentIndex = STATUS_STEPS?.indexOf(volunteer?.status);

  return (
    <div className="bg-card border border-border rounded-xl p-5 md:p-6 shadow-sm">
      <h2 className="text-base md:text-lg font-heading font-semibold text-foreground flex items-center gap-2 mb-5">
        <Icon name="TrendingUp" size={18} color="var(--color-primary)" />
        Your Progress
      </h2>
      {/* Status Journey */}
      <div className="flex items-center gap-1 mb-6 overflow-x-auto pb-1">
        {STATUS_STEPS?.map((step, idx) => {
          const isCompleted = idx < currentIndex;
          const isCurrent = idx === currentIndex;
          return (
            <React.Fragment key={step}>
              <div className="flex flex-col items-center flex-shrink-0">
                <div className={`w-9 h-9 rounded-full flex items-center justify-center border-2 transition-all ${
                  isCompleted ? 'bg-success border-success' : isCurrent ?'bg-primary border-primary': 'bg-muted border-border'
                }`}>
                  <Icon
                    name={isCompleted ? 'Check' : STATUS_ICONS?.[step]}
                    size={15}
                    color={isCompleted || isCurrent ? 'white' : 'var(--color-muted-foreground)'}
                  />
                </div>
                <span className={`text-xs font-caption mt-1 whitespace-nowrap ${isCurrent ? 'text-primary font-semibold' : 'text-muted-foreground'}`}>
                  {STATUS_LABELS?.[step]}
                </span>
              </div>
              {idx < STATUS_STEPS?.length - 1 && (
                <div className={`flex-1 h-0.5 min-w-[20px] mb-4 ${idx < currentIndex ? 'bg-success' : 'bg-border'}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {/* Enrolled Courses Progress */}
      {enrolledCourses?.length > 0 && (
        <div>
          <p className="text-xs font-caption text-muted-foreground uppercase tracking-wide mb-3">Enrolled Courses</p>
          <div className="space-y-3">
            {enrolledCourses?.map((course) => (
              <TrainingProgressIndicator
                key={course?.id}
                courseName={course?.name}
                progress={course?.progress}
                status={course?.status}
                totalModules={course?.totalModules}
                completedModules={course?.completedModules}
                compact={false}
              />
            ))}
          </div>
        </div>
      )}
      {enrolledCourses?.length === 0 && (
        <div className="text-center py-4">
          <Icon name="BookOpen" size={32} color="var(--color-muted-foreground)" />
          <p className="text-sm font-caption text-muted-foreground mt-2">No courses enrolled yet.</p>
        </div>
      )}
    </div>
  );
}